module.exports = __webpack_public_path__ + "img/csv-dropzone-drop.ffbfe559.svg";